import { useEffect, useState } from "react";

export function DesktopClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      setNow(new Date());
      timer = setTimeout(refresh, 60_000 - Date.now() % 60_000 + 20);
    };
    const visible = () => { if (!document.hidden) refresh(); };
    refresh();
    document.addEventListener("visibilitychange", visible);
    return () => { clearTimeout(timer); document.removeEventListener("visibilitychange", visible); };
  }, []);

  const time = new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" }).format(now);
  const date = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit" }).format(now);
  return <time className="taskbar-clock" dateTime={now.toISOString()} title={new Intl.DateTimeFormat("pt-BR", { dateStyle: "full" }).format(now)} aria-label={`${time}, ${date}`}><strong>{time}</strong><span>{date}</span></time>;
}
